var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceGlyphLocation = function SvgInterfaceGlyphLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.01c-3.856 0-6.992 3.138-6.992 6.994 0 4.483 5.967 11.765 6.22 12.072l.772.936.771-.936c.254-.308 6.221-7.59 6.221-12.072 0-3.857-3.136-6.994-6.992-6.994Zm0 2a5 5 0 0 1 4.992 4.994c0 2.705-3.114 7.357-4.992 9.822-1.878-2.463-4.992-7.113-4.992-9.822A5 5 0 0 1 12 4.01Zm0 2.49a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
  })));
};
export default SvgInterfaceGlyphLocation;